import { createStore } from 'vuex';
import * as apiService from '@/api/apiService';
import blockies from 'ethereum-blockies';
import i18n from '@/plugins/i18n';

function covertBigIntsToNumber(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'bigint') {
        // 转换 BigInt 为普通数字
        obj[key] = Number(obj[key]);
    } else if (Array.isArray(obj[key])) {
        // 处理数组
        obj[key] = obj[key].map(item => {
            if (typeof item === 'bigint') {
                return Number(item);
            } else if (typeof item === 'object' && item !== null) {
                // 递归处理对象
                return covertBigIntsToNumber(item);
            }
            return item;
        });
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        // 递归处理对象
        covertBigIntsToNumber(obj[key]);
    }
  }
  return obj; // 返回处理后的对象
}

export default createStore({
  state: {
    isUserLoggedIn: JSON.parse(localStorage.getItem('isUserLoggedIn')) || false,
    isAgent: JSON.parse(localStorage.getItem('isAgent')) || false,
    chainId: 97,
    userProfile: JSON.parse(localStorage.getItem('userProfile')) || {
        avatar: '',
      avatarUrl: '',
      nickname: '',
      lastName: '',
      firstName: '',
      lastLoginTime: 0,
      lastLoginIp: '',
      description: '',
      inviteCode: '',
      referrerAddress: '',
      referrerId: '',
      referralCount: 0,
      agentLevel: 0,
      salesCount: 0,
      balance: 0,
      balanceHistory: [],
      balanceChangeLogs: [],
      walletAddress: '',
      userRole: '',
      userStatus: '',
      userActivationKey: '',
      userLastLogin: '',
      userLastLoginIp: '',
      userLastLoginTime: '',
      userLoginLogs: [],
    },
    token: {
      exp: JSON.parse(localStorage.getItem('tokenExp')) || '',
      iat: JSON.parse(localStorage.getItem('tokenIat')) || '',
      jti: JSON.parse(localStorage.getItem('tokenJti')) || '',
    },
    walletAddress: localStorage.getItem('currWalletAddress') || '',
    cartItems: [],
    announcements: [],
    storeThreshold: JSON.parse(localStorage.getItem('storeThreshold')) || 0,
    usdtContractAddress: localStorage.getItem('usdtContractAddress') || '',
    contractAddress: localStorage.getItem('purchaseContractAddress') || '',
  },
  mutations: {
    SET_USER_LOGGED_IN(state, status) {
      state.isUserLoggedIn = status;
      localStorage.setItem('isUserLoggedIn', JSON.stringify(status));
    },
    SET_USER_PROFILE(state, profile) {
      state.userProfile = { ...profile.data, walletAddress: profile.wallet_address };
      state.walletAddress = profile.wallet_address;
      if(profile.exp) {
        state.token.exp = profile.exp;
        localStorage.setItem('tokenExp', JSON.stringify(state.token.exp));
      }
      if(profile.iat) {
        state.token.iat = profile.iat;
        localStorage.setItem('tokenIat', JSON.stringify(state.token.iat));
      }
      if(profile.jti) {
        state.token.jti = profile.jti;
        localStorage.setItem('tokenJti', JSON.stringify(state.token.jti));
      }
      
      localStorage.setItem('userProfile', JSON.stringify(state.userProfile));
    },
    SET_AVATAR(state, avatar) {
      state.userProfile.avatarUrl = avatar;
      state.userProfile.avatar = avatar;
      localStorage.setItem('avatar', avatar);
    },
    UPDATE_NICKNAME(state, nickname) {
      state.userProfile.nickname = nickname;
      localStorage.setItem('userProfile', JSON.stringify(state.userProfile));
    },
    UPDATE_EMAIL(state, email) {
      state.userProfile.email = email;
      localStorage.setItem('userProfile', JSON.stringify(state.userProfile));
    },
    SET_WALLET_ADDRESS(state, walletAddress) {
      state.userProfile.walletAddress = walletAddress;
      localStorage.setItem('currWalletAddress', walletAddress);
      localStorage.setItem('userProfile', JSON.stringify(state.userProfile));
    },
    SET_AGENT_STATUS(state, status) {
      state.isAgent = status;
      localStorage.setItem('isAgent', JSON.stringify(status));
    },
    LOGOUT(state) {
      state.isUserLoggedIn = false;
      state.isAgent = false;
      state.userProfile = {
        avatarUrl: '',
        profileData: {},
        nickname: '',
        email: '',
        walletAddress: '',
      };
      localStorage.removeItem('isUserLoggedIn');
      localStorage.removeItem('isAgent');
      localStorage.removeItem('userProfile');
      localStorage.removeItem('token');
    },
    UPDATE_PRODUCT_STATE(state, payload) {
      console.log('更新产品状态:', payload);
    },
    SET_CART_ITEMS(state, items) {
      state.cartItems = items;
    },
    SET_ANNOUNCEMENTS(state, announcements) {
      state.announcements = announcements;
    },
    SET_GLOBAL_CONFIG(state, config) {
      state.contractAddress = config.purchase_contract_address;
      state.usdtContractAddress = config.usdt_contract_address;
      state.storeThreshold = config.store_threshold;
    },
  },
  actions: {
    async bindUserAccount({ commit }, { walletAddress, message, signature, inviteCode }) {
      if(walletAddress==='') {
        this.$eventBus.emit('show-snackbar', i18n.t('store.connectWalletError'), 'error', 3000);
        return;
      }
      try {
        const response = await apiService.bindUserAccount({ walletAddress, message, signature, inviteCode });
        if (response.data.success) {
          localStorage.setItem('token', response.data.token);
          const base64Url = response.data.token.split('.')[1];
          const base64 = base64Url.replace(/_/g, '/').replace(/-/g, '+');
          const jsonPayload = atob(base64);
          const userProfile = JSON.parse(jsonPayload);
          const blockie = blockies.create({
            seed: walletAddress,
            size: 128,
            scale: 16,
            color: '#dfe', // main color
            bgcolor: '#a71', // background color
            spotcolor: '#000' // spot color
          });
          commit('SET_USER_PROFILE', userProfile);
          commit('SET_WALLET_ADDRESS', walletAddress);
          commit('SET_USER_LOGGED_IN', true);
          commit('SET_AVATAR', blockie.toDataURL());
          const userInfo = userProfile.data;
          console.log(userInfo, "userProfile" , userProfile);
          commit('SET_AGENT_STATUS', userInfo.userRole == 'agent');
          return { success: true, isAgent: userInfo.userRole == 'agent' };
        } else {
          console.error(i18n.t('store.bindFailed'), response.error);
          this.$eventBus.emit('show-snackbar', response.data.message, 'error', 3000);
          return { success: false, message: response.data.message };
        }
      } catch (error) {
        console.error(i18n.t('store.bindFailed'), error);
        this.$eventBus.emit('show-snackbar', error.response.data.message, 'error', 3000);
        return { success: false, message: error.response.data.message };
      }
    },
    async fetchCartItems({ commit }) {
      try {
        const response = await apiService.fetchCartItems();
        commit('SET_CART_ITEMS', response);
      } catch (error) {
        console.error('Error fetching cart items:', error);
      }
    },
    async fetchAnnouncements({ commit }) {
      try {
        const response = await apiService.fetchAnnouncements();
        commit('SET_ANNOUNCEMENTS', response);
      } catch (error) {
        console.error('Error fetching announcements:', error);
      }
    },
    async fetchUserProfile({ commit }) {
      try {
        const response = await apiService.fetchUserProfile();
        console.log(response, 'vuex store dispatch response');
        commit('SET_USER_PROFILE', response.data);
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    },
    async updateUserNickname({ commit }, nickname) {
      try {
        await apiService.updateUserNickname(nickname);
        commit('UPDATE_NICKNAME', nickname);
      } catch (error) {
        console.error('Error updating user nickname:', error);
      }
    },
    async updateUserEmail({ commit }, email) {
      try {
        await apiService.updateUserEmail(email);
        commit('UPDATE_EMAIL', email);
      } catch (error) {
        console.error('Error updating user email:', error);
      }
    },
    logout({ commit }) {
      commit('LOGOUT');
    },
    async handlePurchaseSuccess({ commit }, eventValues) {
      commit('UPDATE_PRODUCT_STATE', eventValues);
      let response = null;
      try {
        response = await apiService.checkout({
          events: covertBigIntsToNumber(eventValues.event),
          txid: eventValues.event.transactionHash,
          order: eventValues.order,
          receive: eventValues.address,
          invite_address: eventValues.invite_address
        });
        console.log(response, eventValues, "response");
      } catch (error) {
        console.error('Error during checkout:', error);
        response = { success: false, message: error.response.data.message };
      }
      return response;
    },
    setGlobalConfig({ commit }, config) {
      commit('SET_GLOBAL_CONFIG', config.data);
    },
  },
  getters: {
    isUserLoggedIn: (state) => state.isUserLoggedIn,
    userProfile: (state) => state.userProfile,
    walletAddress: (state) => state.walletAddress,
    cartItems: (state) => state.cartItems,
    announcements: (state) => state.announcements,
  },
});
